import React, { Component } from "react";
import { Button } from "../components/Button";
import Input from "../components/Input";
import { FormattedMessage } from "react-intl";
import "./SearchForm.css";

export class SearchForm extends Component {
  submitForm = event => {
    event.preventDefault();
    this.props.fetch(0);
    this.selectedCompetency = "TUT";
  };

  render() {
    const {
      isFormValid,
      searching,
      searchText,
      updateSearchText,
      resetForm,
    } = this.props;

    return (
      <form className='searchForm' onSubmit={this.submitForm}>
        <div className='searchControls'>
          <div className='searchInputContainer'>
            <label>
              <FormattedMessage tagName='label' id='common.person' />
              <Input
                type='text'
                placeholder='pestControlCompetencySearch.personSearchPlaceholder'
                value={searchText}
                onChange={updateSearchText}
              />
            </label>
          </div>
        </div>
        <div className='searchButtonContainer'>
          <div className='validatorMessage' role='alert'>
            {!isFormValid() && <FormattedMessage id='pestControlCompetencySearch.inputError' />}
          </div>
          <Button className='clearLink' onClick={resetForm}>
            <FormattedMessage id='common.clearForm' />
          </Button>
          <Button
            className='searchButton'
            type='submit'
            primary
            search
            disabled={searching || !isFormValid()}
          >
            <FormattedMessage id='common.search' />
          </Button>
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/PestControlCompetencySearch/SearchForm.js